import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { ShaftTippingFraction } from '../../api/models';

export type TABLE_TYPE = Table<ShaftTippingFraction>;

export const TABLE = 'shaftTippingFraction';
const SCHEMA = 'shaftTippingFractionId, sortId';

class ShaftTippingFractionDatabase implements DataRepository<ShaftTippingFraction> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<ShaftTippingFraction | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: ShaftTippingFraction, key: Key): Promise<ShaftTippingFraction> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: ShaftTippingFraction[]): Promise<ShaftTippingFraction[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<ShaftTippingFraction[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const ShaftTippingFractionDB = new ShaftTippingFractionDatabase(db);
